__turbopack_context__.v({
  "menu": "share-dropdown-module-scss-module__hbXbHG__menu",
  "trigger": "share-dropdown-module-scss-module__hbXbHG__trigger",
  "trigger--selected": "share-dropdown-module-scss-module__hbXbHG__trigger--selected",
});
